module.exports = __webpack_public_path__ + "img/yomisuke_theme.f3352261.png";